// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1xgNs","topBottomGutter":"Layout_topBottomGutter__3gC9x"};